import { useQuery } from '@tanstack/react-query';
import { RankGroupsQueryKeys } from '../../queryKeys';
import { fetchRankGroupsWithRanks } from './service';
import { PaginatedResponse } from '@/models/pagination/paginated-response.dto';
import { RankGroup } from '@/models/rank/group';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { UseRankGroupsWithRanksQueryKeys } from './props';
import { useState } from 'react';
import { usePaginatedQuery } from '@starsoft/common/hooks';

export function useRankGroupsWithRanks() {
  const [page, setPage] = useState(1);
  const queryKey: UseRankGroupsWithRanksQueryKeys = [
    RankGroupsQueryKeys.WithRanks,
    {
      limit: 40,
      page,
    },
  ];

  const { data, isPending, error, refetch } = useQuery<
    PaginatedResponse<RankGroup>,
    AxiosError<GenericError>,
    PaginatedResponse<RankGroup>,
    UseRankGroupsWithRanksQueryKeys
  >({ queryKey, queryFn: fetchRankGroupsWithRanks, staleTime: 5 * 1000 });

  const callbacks = usePaginatedQuery({ data, page, setPage });

  return {
    ...callbacks,
    rankGroups: data,
    isLoading: isPending,
    error,
    refetch,
  };
}
